export default __webpack_public_path__ + "static/PHNG-logo-colored-4925bde1079e06e615fc036a7fbfe881.svg";